import AGroup from './Group';
export default AGroup;


// WEBPACK FOOTER //
// ./src/packages/Group/index.js